<template>
  <div class="landing-layout">
    <app-header />
    <router-view />
  </div>
</template>

<script>
import AppHeader from "~/components/AppHeader.vue";
export default {
  name: "LandingLayout",
  components: {
    AppHeader,
  },
};
</script>

<style scoped>
.landing-layout {
  padding: 0px;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.landing-layout .app-header {
  box-shadow: 0 2px 8px 0 rgba(85, 84, 84, 0.2);
}
</style>
